<template>
  <div id="app">
    <header id="header">
      <div class="menu" v-show="!popshow">
        <div class="Her2_menu" @click="popshow = true"></div>
        <a href="https://www.facebook.com/Her2Story" target="_blank">
          <div class="facebook"></div>
        </a>
        <div class="Her2_logo_v"></div>
      </div>
    </header>
    <body class="body jbreal">
      <div class="mystory">
        <div id="occlusion" @mousedown="mousedown" @mouseup="mouseup">
          <ul class="sel_box">
            <li
              data-index="1"
              @click="changeNum(1)"
              :class="num == 1 ? 'sel_box_light' : ''"
            ></li>
            <li
              data-index="2"
              @click="changeNum(2)"
              :class="num == 2 ? 'sel_box_light' : ''"
            ></li>
            <li
              data-index="3"
              @click="changeNum(3)"
              :class="num == 3 ? 'sel_box_light' : ''"
            ></li>
            <li
              data-index="4"
              @click="changeNum(4)"
              :class="num == 4 ? 'sel_box_light' : ''"
            ></li>
            <li
              data-index="5"
              @click="changeNum(5)"
              :class="num == 5 ? 'sel_box_light' : ''"
            ></li>
            <li
              data-index="0"
              @click="changeNum(6)"
              :class="num == 0 ? 'sel_box_light' : ''"
            ></li>
          </ul>
        </div>
        <div id="text1" class="left pic">
          我，是一個乳癌患者，<br />而這是<span style="color: #e14c72"
            >屬於我的乳癌故事</span
          >。
        </div>
        <div id="text2" class="left pic">
          即使患上乳癌，<br />是一個<span style="color: #e14c72"
            >不爭的事實</span
          >，
        </div>
        <div id="text3" class="left pic">
          我，仍然會努力活著，<br />為自己爭取更多<span style="color: #e14c72"
            >精彩時刻</span
          >。
        </div>
        <div id="text4" class="left pic">
          在這個<span style="color: #e14c72">故事</span>裏，
        </div>
        <div id="text5" class="left pic">
          我，還是擁有<br /><span style="color: #e14c72">盼望和夢想</span>，
        </div>
        <div id="text6" class="left pic">
          我，仍然相信可以，<br />編寫出<span style="color: #e14c72"
            >我所期待的結局</span
          >。
        </div>
        <div id="right" class="right">
          <div id="pic1" class="pic"></div>
          <div id="pic2" class="pic"></div>
          <div id="pic3" class="pic"></div>
          <div id="pic4" class="pic"></div>
          <div id="pic5" class="pic"></div>
          <div id="pic6" class="pic"></div>
        </div>
      </div>
      <div id="change-story" class="change-story">
        <div class="change-story-content">
          <div class="change-story-image">
            <div class="change-story-image-INTIRE"></div>
          </div>
          <div class="change-story-font">
            <h1>改寫我的乳癌故事</h1>
            <p>確診患上乳癌的女性，必然會感到沮喪和傍徨。</p>
            <p>
              不過，我們發現她們的抗癌路縱然辛苦，她們往往比身邊的人更滿有生命力。正因為她們明白生命可貴，所以她們會更勇於活出自我，更堅定為自己爭取期待的結局。
            </p>
            <p>
              我們希望藉著「改寫我的乳癌故事」這個主題，讓大家認識這群勇敢對抗頑強癌細胞的女性，以及她們努力主導自己命運的故事。
            </p>
            <p>透過不同的平台，我們會分享一些晚期HER2型乳癌患者的心路歷程。</p>
            <p>
              讓我們一同陪伴她們迎難而上。生命力就是永不放棄，珍惜人生的每一分每一秒，繼續向前走。
            </p>
          </div>
        </div>
        <div class="change-story-small-div"></div>
        <div class="line"></div>
      </div>
      <div id="our-story" class="our-story">
        <div class="line"></div>
        <div class="our-story-flexdiv">
          <div class="our-story-title title-PT-Box">
            <div class="title-PT-GEN">我們的故事</div>
          </div>
        </div>
        <div class="our-story-content">
          <div class="our-story-text">
            <h1>
              當女性確診乳癌那刻時，腦海中第一個問題，很可能是:「為甚麼是我?」
            </h1>
            <p class="paragraph-PT-GEN">
              事實上，乳癌是香港女性患上的最常見癌症，平均每14名女性於75歲之前，有1人有機會患上乳癌，是亞洲中發病率最高的地區之一。<sup
                style="font-size: 0.529vw"
                >1,2</sup
              >
            </p>
            <p class="paragraph-PT-GEN-noTopPadding">
              儘管如此，香港女性具備著柔韌堅毅的特質，面對困難時會勇敢面對，努力克服。就算患上晚期HER2型乳癌，對未來仍是充滿希望，心繫與家人和朋友一起度過的每一刻美好時光。
            </p>
            <p class="paragraph-PT-GEN-noTopPadding">
              我們現正收集晚期HER2型乳癌患者的抗癌故事，並會在不久的將來與大家分享，敬請留意!
            </p>
          </div>
          <div class="our-story-pic">
            <img src="../../public/image/story.png" />
            <img />
          </div>
        </div>

        <div class="our-story-small-div"></div>
        <div class="line"></div>
      </div>
      <div id="her2" class="her2">
        <div class="line"></div>
        <div class="our-story-flexdiv title-PT-Box">
          <div class="our-story-title title-PT-GEN">HER2型乳癌</div>
        </div>
        <div class="her2-text-paragraph">
          <p class="her2-text paragraph-PT-GEN">
            HER2型為香港第二常見的乳癌類別，約20至30%的乳癌患者確診為HER2型乳癌。
            <sup>3</sup>
            <supFix>3</supFix>
            HER2陽性表示患者癌細胞內的HER2(第二型類表皮生長因子)水平較正常多，導致癌細胞以不正常的速度增生及分裂，令腫瘤迅速惡化，是一種擴散較快兼侵略性較高的癌症，而且復發率也較其他乳癌高，因此HER2一直被人視為較棘手和頑強的乳癌類型。<sup
              style="font-size: 0.529vw"
              >4-7</sup
            >
          </p>
          <p class="her2-text paragraph-PT-GEN-noTopPadding">
            乳癌可根據腫瘤的大小、腋下淋巴的腫瘤是否擴散以及腫瘤是否轉移至其他器官而區分為早期和晚期乳癌。<sup
              style="font-size: 0.529vw"
              >8,9</sup
            >
          </p>
        </div>
        <div class="her2-pic">
          <div class="her2-pic-1">
            <div class="her2-pic-1-left">早期</div>
            <div class="her2-pic-1-right">晚期</div>
          </div>
          <div class="her2-pic-2">
            <div>
              <p class="her2-pic-2-title">0至第一期</p>
              <img src="../../public/image/info_stage1.png" alt="" />
              <p class="her2-pic-2-text">
                腫瘤的呎寸小於5公分，腫瘤沒有擴散至腋下淋巴<sup
                  style="font-size: 0.529vw"
                  >9,10</sup
                >
              </p>
            </div>
            <div>
              <p class="her2-pic-2-title">第二期</p>
              <img src="../../public/image/info_stage2.png" alt="" />
              <p class="her2-pic-2-text">
                或許有癌細胞擴散至腋下淋巴的情況出現<sup
                  style="font-size: 0.529vw"
                  >9,10</sup
                >
              </p>
            </div>
            <div>
              <p class="her2-pic-2-title">第三期</p>
              <img src="../../public/image/info_stage3.png" alt="" />
              <p class="her2-pic-2-text">
                乳房腫瘤的癌細胞已擴散至大部分的腋下淋巴<sup
                  style="font-size: 0.529vw"
                  >9,10</sup
                >
              </p>
            </div>
            <div>
              <p class="her2-pic-2-title">第四期</p>
              <img src="../../public/image/info_stage4.png" alt="" />
              <p class="her2-pic-2-text">
                腫瘤已轉移至其他器官，如骨、肝、肺等<sup
                  style="font-size: 0.529vw"
                  >9,10</sup
                ><img
                  id="info_stage_other"
                  src="../../public/image/info_stage_other.png"
                  alt=""
                />
              </p>
            </div>
          </div>
        </div>
        <div class="her2-pic-414">
          <div class="her2-414-left" @click="toleftChange"></div>
          <div class="her2-414-right" @click="torightChange"></div>
          <div class="her2-pic-before">
            <div class="her2-pic-1-left" id="her2-pic-1-left">早期</div>
            <div id="her2-414-pic-1">
              <p class="her2-pic-2-title">0至第一期</p>
              <img src="../../public/image/info_stage1.png" alt="" />
              <p class="her2-pic-2-text">
                腫瘤的呎寸小於5公分，腫瘤沒有擴散至腋下淋巴<sup
                  style="font-size: 0.529vw"
                  >9,10</sup
                >
              </p>
            </div>
            <div id="her2-414-pic-2" class="display-none">
              <p class="her2-pic-2-title">第二期</p>
              <img src="../../public/image/info_stage2.png" alt="" />
              <p class="her2-pic-2-text">
                或許有癌細胞擴散至腋下淋巴的情況出現<sup
                  style="font-size: 0.529vw"
                  >9,10</sup
                >
              </p>
            </div>
          </div>
          <div class="her2-pic-after">
            <div class="her2-pic-1-right display-none" id="her2-pic-1-right">
              晚期
            </div>
            <div id="her2-414-pic-3" class="display-none">
              <p class="her2-pic-2-title">第三期</p>
              <img src="../../public/image/info_stage3.png" alt="" />
              <p class="her2-pic-2-text">
                乳房腫瘤的呎吋大於5公分，癌細胞亦已擴散至大部份的腋下淋巴<sup
                  style="font-size: 0.529vw"
                  >9,10</sup
                >
              </p>
            </div>
            <div id="her2-414-pic-4" class="display-none">
              <p class="her2-pic-2-title">第四期</p>
              <img src="../../public/image/info_stage4.png" alt="" />
              <p class="her2-pic-2-text">
                腫瘤已轉移至其他器官，如骨、肝、肺等<sup
                  style="font-size: 0.529vw"
                  >9,10</sup
                ><img
                  id="info_stage_other"
                  src="../../public/image/info_stage_other.png"
                  alt=""
                />
              </p>
            </div>
          </div>
        </div>
      </div>

      <div id="treatmentPlan" class="treatmentPlan">
        <p class="treatmentPlan-title">HER2型乳癌現時治療方案</p>
        <div class="treatmentPlan-content">
          <div class="treatmentPlan-content-text paragraph-PT-GEN">
            <p class="paragraph-PT-GEN">
              現時有不同類型的治療方案以及治療組合適用於HER2型乳癌，包括:乳房切除手術、放射治療、化療、荷爾蒙治療及標靶治療等。<sup
                style="font-size: 0.529vw"
                >11</sup
              >
            </p>
            <p class="paragraph-PT-GEN-noTopPadding">
              HER2型的晚期乳癌患者或許面對的挑戰不少，但隨著醫學進步，新治療方法有機會為她們帶來希望，而且有助改善她們的生活質素。<sup
                style="font-size: 0.529vw"
                >12</sup
              >
            </p>
          </div>

          <div class="treatmentPlan-content-pic">
            <img src="../../public/image/Her2_IMG2.png" alt="" />
          </div>
        </div>
      </div>

      <div class="treatmentPlan-buttom">
        <div class="line"></div>
        <div class="treatmentPlan-small-div"></div>
      </div>
      <div id="therapeuticTechniques" class="therapeuticTechniques">
        <div class="line"></div>
        <div class="therapeuticTechniques-title title-PT-Box">
          <div class="title-border title-PT-GEN">適用於乳癌之新治療技術</div>
        </div>
        <div class="therapeuticTechniques-content">
          <div class="therapeuticTechniques-pic">
            <!-- <img src="../../public/image/Her2_IMG3.png" alt="" /> -->
               <img src="../../public/image/img3_desktop@2x.png" alt="" />
          </div>
          <div class="therapeuticTechniques-text">
            <p class="paragraph-PT-GEN">
              抗體藥物複合體（以下簡稱為「ADC」），又被稱作為「生物導彈」*。它將單株抗體和藥物兩者結合為一體，成為有效的載荷（payload），而單株抗體就像導彈一樣精準地尋找癌細胞，鎖定目標後便進入癌細胞內釋放載荷，使之死亡。<sup
                style="font-size: 0.529vw"
                >13</sup
              >
            </p>
            <p class="paragraph-PT-GEN">
              如想了解更多，可向你的醫生或藥劑師查詢藥物資訊。
            </p>
            <span
              >*請向醫生了解妳的乳癌情況是否可使用標靶治療，以及它的副作用，因為不是所有乳癌患者都適用此治療。</span
            >
          </div>
        </div>
        <div class="therapeuticTechniques-small-div"></div>
      </div>
      <div id="organization">
        <div class="organization-pc">支援乳癌同路人的組織</div>
        <div class="organization">支援<br />乳癌同路人的組織</div>
      </div>
      <div class="organization-pic">
        <img
          src="../../public/image/HKCF_3D_Pantone_chi.png"
          alt=""
          @click="toLink('https://www.cancer-fund.org/')"
        />
        <img
          src="../../public/image/CICF_2021_CMYK.png"
          alt=""
          @click="toLink('https://cancerinformation.com.hk/')"
        />
        <img
          src="../../public/image/HKACS_LOGO_20180125 (white).png"
          alt=""
          @click="toLink('https://www.hkacs.org.hk/')"
        />
        <img
          src="../../public/image/HK.png"
          alt=""
          @click="toLink('https://www.hkbcf.org/')"
        />
        <img
          src="../../public/image/Standard Logo_registry.png"
          alt=""
          @click="toLink('https://asiabreastregistry.com/')"
        />
        <img
          src="../../public/image/LOGO_1119_D7_arialNarrow.png"
          alt=""
          @click="toLink('https://www.gcbcoa.org/')"
        />
      </div>
      <div class="reference">
        <p class="bibliography">參考文獻</p>
        <table style="width: 100%" cellpadding="2" cellspacing="0" border="0">
          <tbody>
            <tr>
              <td class="number">1.</td>
              <td>
                Hospital Authority. Female breast cancer in 2019. Available at:www3.ha.org.hk/cancereg/pdf/factsheet/2019/breast_2019.pdf.Accessed March 2022.
              </td>
            </tr>

            <tr>
              <td class="number">2.</td>
              <td>
                Hong Kong Breast Cancer Foundation. About us. Available at:www.hkbcf.org/zh/about_us/main/upload/category/442/self/6080f6626cbd1.pdf.AccessedMarch 2022.
              </td>
            </tr>

            <tr>
              <td class="number">3.</td>
              <td>
                Hong Kong Breast Cancer Foundation. Hong Kong Breast Cancer Registry report no.13 (Issue 2021) Chapter 2. Available at:www.hkbcf.org/upload/category/653/self/6149340aa089c.pdf. Accessed March 2022.
              </td>
            </tr>

            <tr>
              <td class="number">4.</td>
              <td>
                American Cancer Society. Breast cancer HER2 status. Available at:www.cancer.org/cancer/breast-cancer/understanding-a-breast-cancer-diagnosis/breast-cancer-her2-status.html.Accessed March 2022.
              </td>
            </tr>

            <tr>
              <td class="number">5.</td>
              <td>
                Mayo Clinic. Breast cancer types: What your type means.Available at:www.mayoclinic.org/diseases-conditions/breast-cancer/in-depth/breast-cancer/art-20045654.Accessed March 2022.
              </td>
            </tr>

            <tr>
              <td class="number">6.</td>
              <td>
                Breastcancer.org. HER2 status. Available at:www.breastcancer.org/pathology-report/her2-status. Accessed March 2022.
              </td>
            </tr>

            <tr>
              <td class="number">7.</td>
              <td>Iqbal N, et al. Mol Biol Int 2014;2014:852748.</td>
            </tr>

            <tr>
              <td class="number">8.</td>
              <td>
                Cancer.Net. Breast cancer: Stages. Available at:www.cancer.net/cancer-types/breast-cancer/stages. Accessed March 2022.
              </td>
            </tr>

            <tr>
              <td class="number">9.</td>
              <td>
                Cancer Research UK. About breast cancer staging and grades.Available at:www.cancerresearchuk.org/about-cancer/breast-cancer/stages-types-grades/about-breast-cancer-staging-grades.Accessed March 2022.
              </td>
            </tr>

            <tr>
              <td class="number">10.</td>
              <td>
                Breastcancer.org. Breast cancer stages. Available at:www.breastcancer.org/pathology-report/breast-cancer-stages.Accessed March 2022.
              </td>
            </tr>

            <tr>
              <td class="number">11.</td>
              <td>
                UpToDate. Patient education: Treatment of early HER2-positive breast cancer (beyond the basics). Available at:www.uptodate.com/contents/treatment-of-early-her2-posi-tive-breast-cancer-beyond-the-basics/print.
                Accessed March 2022.
              </td>
            </tr>
            <tr>
              <td class="number">12.</td>
              <td>Martinez-Saez O, et al. JCO Oncol Pract 2021;17:594-604.</td>
            </tr>

            <tr>
              <td class="number">13.</td>
              <td>
                Biopharma Dealmakers. Guided missiles: antibody–drug conjugates.Available at: www.nature.com/articles/d43747-020-00365-0.Accessed March 2022
              </td>
            </tr>
          </tbody>
        </table>

        <p class="disclaimer">免責聲明</p>
        <p class="disclaimer-text">
          <span>此網站為香港市民提供疾病資訊。</span>
        </p>
        <p class="disclaimer-text text-display2">
          <span
            >本網站內所提供之資料僅供學術或參考用途，並不能取代醫生及其他醫護專業人員的意見。雖然我們已盡力確保網站的資料準確，但不會保證該等資料的準確性，
          </span>
        </p>
        <p class="disclaimer-text text-display2">
          <span
            >亦不會對任何資料上的錯誤或遺漏承擔法律責任。如對資訊有任何疑問，請向你的醫生查詢。</span
          >
        </p>
        <p class="disclaimer-text text-display">
          <span
            >本網站內所提供之資料僅供學術或參考用途，並不能取代醫生及其他醫護專業人員的意見。雖然我們已盡力確保網站的資料準確，但不會保證該等資料的準確性，亦不會對任何資料上的錯誤或遺漏承擔法律責任。如對資訊有任何疑問，請向你的醫生查詢。
          </span>
        </p>
      </div>
    </body>
    <footer>
      <div class="contactUs">
        <p class="contactUs-title">
          <span>聯絡我們</span><br />
          如有任何關於阿斯利康或第一三共產品的疑問，請向你的醫生或藥劑師查詢。
        </p>
        <div class="contactUs-pic">
          <div style="margin-right: 50px">
            <div class="DaiiChi-Sankyo">
              <img src="../../public/image/Logo_Daiichi-sankyo@2x.png" alt="" />
            </div>
            <div class="contactUs-pic-text">
              <p><span class="sansHk">香港第一三共有限公司</span></p>
              <p class="inline">
                香港銅鑼灣告士打道 255-257號信和廣場12樓1205室
              </p>
              <p>Tel: (852) 2868 9079</p>
              <p>Fax: (852) 2801 4341</p>
              <a href="https://www.DaiichiSankyo.com.hk" title=""
                >www.DaiichiSankyo.com.hk</a
              >
            </div>
          </div>
          <div>
            <div class="AstraZeneca">
              <img src="../../public/image/Logo_AZ@2x.png" alt="" />
            </div>
            <div class="contactUs-pic-text">
              <p><span>阿斯利康（香港）有限公司</span></p>
              <p class="inline">香港北角京華道18號11樓1-3室</p>
              <p>Tel: (852) 2420 7388</p>
              <p>Fax: (852) 2422 6788</p>
              <a href="https://www.AstraZeneca.com.hk" title=""
                >www.AstraZeneca.com.hk</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="privacyLaw">
        <div class="privacyLaw-left">
          <p>
            <a
              href="https://www.globalprivacy.astrazeneca.com/CN-Traditional"
              target="_blank"
              >私隱政策聲明</a
            >
            |
            <a
              href="https://www.astrazeneca.com.hk/index/legal-statement"
              target="_blank"
              >法律聲明及使用條款</a
            >
            |
            <a
              href="https://us-cookienotice.astrazeneca.com/cookie-notice.html#cookie
"
              target="_blank"
              >Cookies政策</a
            >
          </p>
        </div>
        <div class="privacyLaw-right">
          <p>
            <span>版權所有©2022</span>
            <span>阿斯利康(香港)有限公司 香港第一三共有限公司</span>
          </p>
          <!-- <p>HK-7225 18/06/2022</p> -->
          <!-- <p>DS: HK-DAI-ENH-2208008</p>
<p>AZ: HK-7738 15/09/2022</p> -->
<p  >
  <span class="privacyLaw-bottom" >HK-DAI-ENH-2208008</span>
  <span>HK-7738 15/09/2022</span>
</p>
          </ul>
        </div>
      </div>
    </footer>

    <div class="pop-up" v-show="popshow">
      <!-- <img class="pop-up-close" @click="popshow = false" src="../../public/svg/Close.svg" alt=""> -->
      <div class="pop-up-close" id="close-png" @click="popshow = false"></div>
      <img
        class="pop-img-logo"
        src="../../public/logo/Her2_70x70@2x.png"
        alt=""
      />
      <div class="pop-up-menu-items-first">
        <a href="javascript:;" @click="topMao('#change-story')"
          >改寫我的乳癌故事</a
        >
        <a href="javascript:;" @click="topMao('#our-story')">我們的故事</a>
      </div>
      <div>
        <a href="javascript:;" @click="topMao('#treatmentPlan')"
          >HER2型乳癌現時治療方案</a
        >
        <a href="javascript:;" @click="topMao('#therapeuticTechniques')"
          >適用於乳癌之新治療技術</a
        >
      </div>
      <div>
        <a href="javascript:;" @click="topMao('#her2')">HER2型乳癌</a>
        <a href="javascript:;" @click="topMao('#organization')"
          >支援乳癌同路人的組織</a
        >
      </div>
      <div class="pop-up-follow">
        <!-- <img class="pop-img-logo" src="../../public/svg/Facebook.svg" alt=""> -->

        <a
          class="pop-up-follow-a menu-facebook"
          href="https://www.facebook.com/Her2Story"
          ><div id="facebook-small"></div>
          Follow Us</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "her2",
  props: {
    msg: String,
  },
  components: {},
  data() {
    return {
      num: 1,
      x1: "",
      x2: "",
      periods: 1,
      popshow: false,
    };
  },
  methods: {
    animation2: function (click) {
      console.log("开始");
      for (let index = 0; index < 6; index++) {
        document.getElementById(`pic${index + 1}`).classList.remove("active");
        document.getElementById(`pic${index + 1}`).classList.add("pic");
        document
          .getElementById(`text${index + 1}`)
          .classList.remove("active-text");
        document.getElementById(`text${index + 1}`).classList.add("pic");
      }

      occlusion.addEventListener("mouseenter", function () {
        clearInterval(timer);
        timer = null;
      });

      occlusion.addEventListener("mouseleave", function () {
        timer = setInterval(function () {
          right.click();
        }, 2000);
      });

      var timer = setInterval(function () {
        right.click();
      }, 2000);

      document.getElementById(`pic${this.num}`).classList.remove("pic");
      document.getElementById(`pic${this.num}`).classList.add("active");
      document.getElementById(`text${this.num}`).classList.remove("pic");
      document.getElementById(`text${this.num}`).classList.add("active-text");
      if (this.num >= 6) {
        this.num = 0;
      }
      if (click) {
        for (let i = 1; i < 100000; i++) {
          clearInterval(i);
        }
        setInterval(() => {
          this.num = this.num + 1; //  6
          for (let index = 0; index < 6; index++) {
            document
              .getElementById(`pic${index + 1}`)
              .classList.remove("active");
            document.getElementById(`pic${index + 1}`).classList.add("pic");
            document
              .getElementById(`text${index + 1}`)
              .classList.remove("active-text");
            document.getElementById(`text${index + 1}`).classList.add("pic");
          }
          document.getElementById(`pic${this.num}`).classList.remove("pic");
          document.getElementById(`pic${this.num}`).classList.add("active");
          document.getElementById(`text${this.num}`).classList.remove("pic");
          document
            .getElementById(`text${this.num}`)
            .classList.add("active-text");
          if (this.num == 6) {
            this.num = 0;
          }
        }, 4000);
      } else {
        setInterval(() => {
          this.num = this.num + 1; //  6
          for (let index = 0; index < 6; index++) {
            document
              .getElementById(`pic${index + 1}`)
              .classList.remove("active");
            document.getElementById(`pic${index + 1}`).classList.add("pic");
            document
              .getElementById(`text${index + 1}`)
              .classList.remove("active-text");
            document.getElementById(`text${index + 1}`).classList.add("pic");
          }
          document.getElementById(`pic${this.num}`).classList.remove("pic");
          document.getElementById(`pic${this.num}`).classList.add("active");
          document.getElementById(`text${this.num}`).classList.remove("pic");
          document
            .getElementById(`text${this.num}`)
            .classList.add("active-text");
          if (this.num == 6) {
            this.num = 0;
          }
        }, 4000);
      }
    },
    changeNum: function (num) {
      console.log(num);
      this.num = num;
      this.animation2("click");
    },
    mousedown: function (e) {
      this.x1 = e.pageX;
    },
    mouseup: function (e) {
      this.x2 = e.pageX;
      if (this.x2 - this.x1 > 0) {
        console.log("左滑");
        this.num = this.num - 1;
        if (this.num == -1) {
          this.num = 5;
        }
        if (this.num <= 0) {
          this.num = 6;
        }
        this.animation2("click");
      } else if (this.x2 - this.x1 < 0) {
        console.log("右滑");
        this.num = this.num + 1;
        if (this.num > 6) {
          this.num = 0;
        }
        this.animation2("click");
      }
    },
    torightChange: function () {
      console.log(this.periods);
      this.periods += 1;
      if (this.periods > 4) {
        this.periods = 1;
      }
      console.log(document.getElementById("her2-pic-1-left").classList);
      document.getElementById("her2-pic-1-left").classList.add("display-none");
      document.getElementById("her2-pic-1-right").classList.add("display-none");
      for (let i = 0; i < 4; i++) {
        document
          .getElementById(`her2-414-pic-${i + 1}`)
          .classList.add("display-none");
      }
      if (this.periods < 3) {
        document
          .getElementById("her2-pic-1-left")
          .classList.remove("display-none");
      } else {
        document
          .getElementById("her2-pic-1-right")
          .classList.remove("display-none");
      }
      document
        .getElementById(`her2-414-pic-${this.periods}`)
        .classList.remove("display-none");
    },
    toleftChange: function () {
      this.periods -= 1;
      if (this.periods < 1) {
        this.periods = 4;
      }
      document.getElementById("her2-pic-1-left").classList.add("display-none");
      document.getElementById("her2-pic-1-right").classList.add("display-none");
      for (let i = 0; i < 4; i++) {
        document
          .getElementById(`her2-414-pic-${i + 1}`)
          .classList.add("display-none");
      }
      if (this.periods < 3) {
        document
          .getElementById("her2-pic-1-left")
          .classList.remove("display-none");
      } else {
        document
          .getElementById("her2-pic-1-right")
          .classList.remove("display-none");
      }
      document
        .getElementById(`her2-414-pic-${this.periods}`)
        .classList.remove("display-none");
    },
    handleClose: function (done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    toLink: function (herf) {
      window.open(herf, "_blank");
    },
    topMao: function (target) {
      this.popshow = false;
      let height = $("#header").height();
      $("html, body").animate(
        { scrollTop: $(target).offset().top - height },
        500
      ); //130为锚点到距顶部的距离，500为执行时间
      return false;
    },
  },
  mounted() {
    this.animation2();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only

-->
<style  scoped>
</style>








// WEBPACK FOOTER //
// src/components/her2.vue